import PartnerTemplate from '../components/marketing/PartnerTemplate';

/* IncredibleBank — customer / prospect page (Clarid-only lockup, no co-branding). */
export default function IncredibleBankPartnerPage() {
  return (
    <PartnerTemplate
      docTitle="Clarid — The Compliance Operating System for Incredibly Ambitious Banks"
      lockup="clarid-only"
      partnerName="IncredibleBank"
      eyebrow="§ PREPARED FOR INCREDIBLEBANK"
      headline={<>The compliance operating system for <span className="frame-quote">incredibly ambitious</span> banks.</>}
      lead="Clarid is the AI-native compliance platform built for community banks operating across multiple states and multiple MSAs. Marketing compliance, HMDA, fair lending, CRA, and regulatory change — unified in one system, with examiner-ready audit trails on every action and the methodology depth of a consulting engagement built into the platform."
      heroNote="Wisconsin · Michigan UP · Southwest Florida — three states, one compliance program"
      thesisKicker="§ 01 · WHY IT FITS"
      thesisHeadline="Growth adds compliance surface area faster than compliance teams."
      thesis={[
        {
          well: '01',
          title: 'One program across every footprint',
          body: 'A bank running from Wausau to the Upper Peninsula to Cape Coral has three demographic profiles and one compliance obligation. Clarid runs them as a single connected program, not three spreadsheets.',
        },
        {
          well: '02',
          title: 'Consulting-grade methodology, in the platform',
          body: 'The depth a consulting engagement provides — fair-lending risk factors, CRA assessment-area analysis, pricing regression — built into the product, without the per-engagement cost.',
        },
        {
          well: '03',
          title: 'Examiner-ready on every action',
          body: 'Every check is timestamped and SHA-256-verified, so multi-MSA growth never outruns the evidence trail.',
        },
      ]}
      bringsHeadline="Every module, one connected program."
      depth={[
        { label: 'Marketing', txt: 'Every ad, email, and disclosure checked against FDIC Part 328, Reg Z / DD / B, Fair Housing, and UDAAP — AI detection, deterministic rules, human approval.' },
        { label: 'HMDA', txt: '170+ CFPB edit checks, LAR validation, geocoding, and submission-ready exports across every MSA.' },
        { label: 'Fair lending · CRA', txt: 'IFLEP fair-lending risk factors, regression reproducing the FRB tool, and CRA assessment-area analysis across all three states.' },
      ]}
      proofs={[
        { stat: '170+ HMDA edit checks', desc: 'Full LAR validation against the current edit-check set, across every assessment area.' },
        { stat: 'FRB Fair Lending Tool — to the decimal', desc: "Clarid reproduces the Federal Reserve's fair-lending methodology exactly, not an approximation." },
        { stat: 'Deterministic · multi-provider', desc: "Circuit-breaker fallback across providers — it kept running through Anthropic's largest-ever outage. SHA-256-verified exam packages." },
      ]}
      integration={{
        kicker: '§ 03 · HOW IT RUNS',
        headline: 'One compliance program across three states.',
        lead: 'Marketing, HMDA, fair lending, and CRA run as one connected program across every assessment area IncredibleBank operates in.',
        barLabel: 'clarid.os · one program · every MSA',
        flow: [
          { name: 'Three-state footprint', sub: 'WI · MI UP · SW FL — distinct demographics' },
          { name: 'Clarid · one program', sub: 'Marketing · HMDA · fair lending · CRA · exam', clarid: true },
          { name: 'Examiner-ready', sub: 'Every MSA · connected audit trail' },
        ],
        tags: [
          { label: '✓ Marketing · shipped', kind: 'shipped' },
          { label: '✓ HMDA · shipped', kind: 'shipped' },
          { label: '✓ Fair lending & CRA · shipped', kind: 'shipped' },
        ],
      }}
      contact={{ name: 'Bobby Sloan', title: 'Founder & CEO, Clarid', email: 'bobby@clarid.ai' }}
    />
  );
}
